export default __webpack_public_path__ + "static/identify-light-fb6131fa49305da2e2ecf1ba58845297.png";